// In-memory token store — avoids localStorage for auth tokens.
// sessionStorage is used as a fallback for page refresh.
// When the backend starts setting httpOnly cookies, remove the
// sessionStorage reads/writes and set withCredentials only.
let _token = null;

const tokenStore = {
  // Self-healing read: if the in-memory token isn't populated yet — e.g. a
  // child component fires an adminApi request on a fresh load/refresh BEFORE
  // AuthProvider's useEffect runs init() (child effects run before parent
  // effects), or after a remount, or from a background poller — fall back to
  // the sessionStorage copy so EVERY request carries the Bearer. Without this,
  // such a request goes out unauthenticated → 401 → the response interceptor
  // clears the token and redirects to '/', i.e. a spurious mid-session logout
  // (notably mid-wizard, since the package editor makes no API calls between
  // steps). Tokens never expire server-side (Sanctum expiration=null), so a
  // persisted token is always still valid.
  get:   () => {
    if (!_token) _token = sessionStorage.getItem('pp_token');
    return _token;
  },
  set:   (token) => {
    _token = token;
    if (token) sessionStorage.setItem('pp_token', token);
    else       sessionStorage.removeItem('pp_token');
  },
  init:  () => {
    _token = sessionStorage.getItem('pp_token') || null;
    return _token;
  },
  clear: () => {
    _token = null;
    sessionStorage.removeItem('pp_token');
  },
};

export default tokenStore;
